import React from "react";
import ListItem from "@screens/SupportTree/components/ListItem";
import { useDispatch } from "react-redux";
import { actions } from "@reducers/supportReducer";
import navigateToListOrItem from "../utils/navigateToListOrItem";

const SupportListItem = (props) => {
  const {
    title,
    navigation,
    navigationKey,
    navigationParams,
    nextAction,
    nextId,
    dataKey,
    render,
    dataValue,
    isFocused,
  } = props;
  const dispatch = useDispatch();
  return (
    <ListItem
      title={title}
      onPress={() => {
        if (isFocused) {
          if (navigationKey) {
            return navigation.navigate(
              navigationKey,
              navigationParams ? JSON.parse(navigationParams) : {},
            );
          }
          if (dataKey && dataValue) {
            dispatch(
              actions.updateSupportTicketPayload({
                dataKey,
                render,
                value: dataValue,
              }),
            );
          }
          navigateToListOrItem(props);
        }
      }}
    />
  );
};

export default SupportListItem;
